export const businessmodels = [
  'B2B',
  'B2C',
  'B2B2C'
]

export default businessmodels
